var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "info-a",
    d: "M11,20.4285714 C16.2072562,20.4285714 20.4285714,16.2072562 20.4285714,11 C20.4285714,5.79274379 16.2072562,1.57142857 11,1.57142857 C5.79274379,1.57142857 1.57142857,5.79274379 1.57142857,11 C1.57142857,16.2072562 5.79274379,20.4285714 11,20.4285714 Z M11,22 C4.92486775,22 0,17.0751322 0,11 C0,4.92486775 4.92486775,0 11,0 C17.0751322,0 22,4.92486775 22,11 C22,17.0751322 17.0751322,22 11,22 Z M11.0245536,7.93080357 C10.1566775,7.93080357 9.453125,7.22725104 9.453125,6.359375 C9.453125,5.49149896 10.1566775,4.78794643 11.0245536,4.78794643 C11.8924296,4.78794643 12.5959821,5.49149896 12.5959821,6.359375 C12.5959821,7.22725104 11.8924296,7.93080357 11.0245536,7.93080357 Z M9.82142857,15.7142857 L9.82142857,11 L9.42857143,11 C8.99463341,11 8.64285714,10.6482237 8.64285714,10.2142857 C8.64285714,9.7803477 8.99463341,9.42857143 9.42857143,9.42857143 L11.3928571,9.42857143 C11.8267952,9.42857143 12.1785714,9.7803477 12.1785714,10.2142857 L12.1785714,15.7142857 L12.5714286,15.7142857 C13.0053666,15.7142857 13.3571429,16.066062 13.3571429,16.5 C13.3571429,16.933938 13.0053666,17.2857143 12.5714286,17.2857143 L9.42857143,17.2857143 C8.99463341,17.2857143 8.64285714,16.933938 8.64285714,16.5 C8.64285714,16.066062 8.99463341,15.7142857 9.42857143,15.7142857 L9.82142857,15.7142857 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "info-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#info-a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#13C2C2",
    mask: "url(#info-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 -1 23)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.63517522.svg";
export { ForwardRef as ReactComponent };